import { Plugin } from '@ckeditor/ckeditor5-core';
import { Widget } from '@ckeditor/ckeditor5-widget';
import RecorderInlineEditing from './recorder/recorderinlineediting';
import './theme/recorder.css';

export default class RecorderInline extends Plugin {
    /**
     * @inheritDoc
     */
    static get requires() {
        return [ RecorderInlineEditing, Widget ];
    }

    /**
     * @inheritDoc
     */
    static get pluginName() {
        return 'RecorderInline';
    }
}
